var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getToken } from './authentication';
import { services } from './services';
export var api = {
    get: function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, _b, _c, hasData, result, _d;
        var _e, _f, _g;
        var _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _a = fetch;
                    _b = [url];
                    _e = {};
                    _f = {
                        'Content-Type': 'application/json'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 1:
                    _f.authorization = _c.apply("Bearer ", [_j.sent()]),
                        _f['Content-Security-Policy'] = " default-src 'self'";
                    return [4 /*yield*/, services.getTenant()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_e.headers = (_f.Tenant = _j.sent(),
                            _f),
                            _e)])).catch(function (err) {
                        return createResponse(400, err, "UI-Error occurred at: " + url);
                    })];
                case 3:
                    response = _j.sent();
                    hasData = (_h = response === null || response === void 0 ? void 0 : response.ok) !== null && _h !== void 0 ? _h : false;
                    _g = {};
                    if (!hasData) return [3 /*break*/, 5];
                    return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.json())];
                case 4:
                    _d = _j.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _d = undefined;
                    _j.label = 6;
                case 6:
                    result = (_g.data = _d,
                        _g.error = !hasData,
                        _g.loading = false,
                        _g.status = response.status,
                        _g);
                    return [2 /*return*/, result];
            }
        });
    }); },
    getNoNull: function (url, isNotJson) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, _b, _c, hasData, result, _d, _e;
        var _f, _g, _h;
        var _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _a = fetch;
                    _b = [url];
                    _f = {};
                    _g = {
                        'Content-Type': 'application/json'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 1:
                    _g.authorization = _c.apply("Bearer ", [_k.sent()]),
                        _g['Content-Security-Policy'] = " default-src 'self'";
                    return [4 /*yield*/, services.getTenant()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_f.headers = (_g.Tenant = _k.sent(),
                            _g),
                            _f)])).catch(function (err) {
                        return createResponse(400, err, "Error occurred at: " + url);
                    })];
                case 3:
                    response = _k.sent();
                    hasData = (_j = ((response === null || response === void 0 ? void 0 : response.ok) && (response === null || response === void 0 ? void 0 : response.status) != 204)) !== null && _j !== void 0 ? _j : false;
                    _h = {};
                    if (!hasData) return [3 /*break*/, 8];
                    if (!isNotJson) return [3 /*break*/, 5];
                    return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.text())];
                case 4:
                    _e = _k.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.json())];
                case 6:
                    _e = _k.sent();
                    _k.label = 7;
                case 7:
                    _d = (_e);
                    return [3 /*break*/, 9];
                case 8:
                    _d = undefined;
                    _k.label = 9;
                case 9:
                    result = (_h.data = _d,
                        _h.error = !hasData,
                        _h.loading = false,
                        _h.status = response.status,
                        _h.isSuccess = response ? response.status >= 200 && response.status < 300 : false,
                        _h);
                    return [2 /*return*/, result];
            }
        });
    }); },
    post: function (url, data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, _b, _c, hasData, result, _d;
        var _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _a = fetch;
                    _b = [url];
                    _e = {
                        method: 'post'
                    };
                    _f = {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        Accept: 'application/json'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 1:
                    _f.authorization = _c.apply("Bearer ", [_h.sent()]),
                        _f['Content-Security-Policy'] = " default-src 'self'";
                    return [4 /*yield*/, services.getTenant()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_e.headers = (_f.Tenant = _h.sent(),
                            _f),
                            _e.mode = 'cors',
                            _e.body = data,
                            _e)])).catch(function (err) {
                        return createResponse(400, err, "Error occurred at: " + url);
                    })];
                case 3:
                    response = _h.sent();
                    hasData = response.ok;
                    _g = {};
                    if (!hasData) return [3 /*break*/, 5];
                    return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.json())];
                case 4:
                    _d = _h.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _d = undefined;
                    _h.label = 6;
                case 6:
                    result = (_g.data = _d,
                        _g.error = !hasData,
                        _g.loading = false,
                        _g.status = response.status,
                        _g);
                    return [2 /*return*/, result];
            }
        });
    }); },
    getAsBlob: function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, _b, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = fetch;
                    _b = [url];
                    _d = {};
                    _e = {
                        'Content-Type': 'application/octet-stream'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 1:
                    _e.authorization = _c.apply("Bearer ", [_f.sent()]),
                        _e.responseType = 'arraybuffer',
                        _e.dataType = 'blob',
                        _e['Content-Security-Policy'] = " default-src 'self'";
                    return [4 /*yield*/, services.getTenant()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_d.headers = (_e.Tenant = _f.sent(),
                            _e),
                            _d)]))];
                case 3:
                    response = _f.sent();
                    if (!response.ok) {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, response.blob()];
            }
        });
    }); },
    delete: function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, _b, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = fetch;
                    _b = [url];
                    _d = {
                        method: 'delete'
                    };
                    _e = {
                        'Access-Control-Allow-Origin': '*',
                        Accept: 'application/json'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 1:
                    _e.authorization = _c.apply("Bearer ", [_f.sent()]),
                        _e['Content-Security-Policy'] = " default-src 'self'";
                    return [4 /*yield*/, services.getTenant()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_d.headers = (_e.Tenant = _f.sent(),
                            _e),
                            _d.mode = 'cors',
                            _d)])).catch(function (err) {
                        return createResponse(400, err, "Error occurred at: " + url);
                    })];
                case 3:
                    response = _f.sent();
                    return [2 /*return*/, response.ok];
            }
        });
    }); },
};
var createResponse = function (status, err, errMsg) {
    var source;
    if (errMsg.includes('/account/')) {
        source = 'For more information => Check Account service Logs';
    }
    else if (errMsg.includes('/app/')) {
        source = 'For more information => Check Application service Logs';
    }
    var error = { message: errMsg, StackTrace: source };
    console.log('createResponse', error);
    services.logError(error);
    var strFunc = new Promise(function (resolve) {
        resolve(err !== null && err !== void 0 ? err : '');
    });
    var headFunc = new Promise(function (resolve) {
        resolve(new Headers());
    });
    return {
        headers: new Headers(),
        ok: false,
        redirected: false,
        status: status,
        statusText: '',
        // trailer: headFunc,
        type: 'default',
        url: '',
        clone: function () {
            return null;
        },
        bodyUsed: false,
        body: null,
        arrayBuffer: null,
        blob: null,
        formData: null,
        json: function () { return strFunc; },
        text: function () { return strFunc; },
    };
};
